<template>
  <div class="phone-display-app">
    <!-- 背景装饰光斑 -->
    <div class="bg-decoration bg-1"></div>
    <div class="bg-decoration bg-2"></div>

    <el-loading fullscreen="true" v-if="isLoad" custom-class="glass-loading" text="加载中..."></el-loading>
    
    <div class="main-container">
      <div class="header">
        <div class="header-content">
          <h1>水电管理</h1>
          <p class="date">{{ currentDate }}</p>
        </div>
        <!-- <div class="header-avatar">
          <i class="el-icon-user-solid"></i>
        </div> -->
      </div>

      <div class="content-scroll">
        <div class="content-grid">
          <div v-for="(item, index) in data" :key="item.id" 
               class="item-card" 
               :style="{ animationDelay: `${index * 0.05}s` }"
               @click="handleItemClick(item)">
            <div class="item-icon-wrapper">
            <!-- <div class="item-icon-wrapper" :class="`icon-bg-${index % 5}`"> -->
              <div v-if="!item.image || item.image.startsWith('el-icon')" class="avatar-text-phone">{{ getAvatarText(item.url_name) }}</div>
              <img v-else :src="item.image" class="item-icon" @error="imageError(item)" alt="">
            </div>
            <span class="item-name">{{ item.url_name }}</span>
            <i class="el-icon-arrow-right card-arrow" v-if="item.list && item.list.length > 0"></i>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="showChildren" :fullscreen="true" :show-close="false" custom-class="glass-dialog">
      <div class="dialog-header">
        <div class="back-btn" @click="showChildren = false">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <span class="dialog-title">{{ currentTitle }}</span>
        <div class="placeholder"></div>
      </div>
      <div class="dialog-content">
        <div class="content-grid">
          <div v-for="(item, index) in childrenData" :key="item.id" 
               class="item-card" 
               :style="{ animationDelay: `${index * 0.05}s` }"
               @click="handleItemClick(item)">
            <div class="item-icon-wrapper">
            <!-- <div class="item-icon-wrapper" :class="`icon-bg-${(index + 2) % 5}`"> -->
              <div v-if="!item.image || item.image.startsWith('el-icon')" class="avatar-text-phone">{{ getAvatarText(item.url_name) }}</div>
              <img v-else :src="item.image" class="item-icon" @error="imageError(item)" alt="">
            </div>
            <span class="item-name">{{ item.url_name }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import dayjs from 'dayjs'; // 假设项目中有dayjs，如果没有可以用原生Date

export default {
  name: 'PhoneDisplay',
  computed: {
    getAvatarText() {
      return (name) => {
        if (!name) return '';
        if (name.length > 2) {
          return name.substring(name.length - 2);
        }
        return name;
      };
    },
    currentDate() {
      const now = new Date();
      const options = { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' };
      return now.toLocaleDateString('zh-CN', options);
    }
  },
  data() {
    return {
      api_url: '/api',
      data: [],
      childrenData: [],
      isLoad: false,
      showChildren: false,
      currentTitle: '下级菜单',
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoad = true;
      try {
        const response = await this.$http.get(`${this.api_url}/kbgl/get_myurl`);
        this.data = response.data.DATA;
      } catch (err) {
        this.$message({
          type: 'error',
          message: err.response ? err.response.data.RTN_MSG : '网络错误',
          duration: 3000,
        });
      } finally {
        this.isLoad = false;
      }
    },
    handleItemClick(item) {
      if (item.list && item.list.length > 0) {
        this.childrenData = item.list;
        this.currentTitle = item.url_name;
        this.showChildren = true;
      } else if (item.url) {
        window.open(item.url, '_blank');
      }
    },
    imageError(item) {
      this.$set(item, 'image', 'el-icon-picture-outline');
    }
  }
}
</script>

<style scoped>
/* 全局容器与背景 */
.phone-display-app {
  position: relative;
  min-height: 100vh;
  background-color: #f0f2f5;
  overflow-x: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", Arial, sans-serif;
  color: #1d1d1f;
}

/* 装饰性背景光斑 */
.bg-decoration {
  position: fixed;
  border-radius: 50%;
  filter: blur(80px);
  z-index: 0;
  opacity: 0.6;
}

.bg-1 {
  top: -100px;
  left: -100px;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, #a1c4fd 0%, #c2e9fb 100%);
}

.bg-2 {
  bottom: -50px;
  right: -50px;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, #ffecd2 0%, #fcb69f 100%);
}

.main-container {
  position: relative;
  z-index: 1;
  padding: 20px;
  padding-bottom: 40px;
}

/* 头部样式 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-top: 20px;
}

.header h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(120deg, #2c3e50, #3498db);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.header .date {
  margin: 5px 0 0;
  font-size: 13px;
  color: #86868b;
  font-weight: 500;
}

.header-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  color: #555;
  font-size: 20px;
}

/* 网格布局 */
.content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(105px, 1fr));
  gap: 16px;
}

/* 卡片样式 - 核心设计 */
.item-card {
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  cursor: pointer;
  aspect-ratio: 1 / 1.1;
  position: relative;
  animation: fadeUp 0.6s ease-out backwards;
}

.item-card:active {
  transform: scale(0.96);
  background: rgba(255, 255, 255, 0.8);
}

.card-arrow {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 12px;
  color: #bbb;
}

/* 图标容器 - 增加多彩背景 */
.item-icon-wrapper {
  width: 56px;
  height: 56px;
  border-radius: 18px;
  margin-bottom: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 24px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  box-shadow: 0px 0px 6px #857f7f;
}

.item-card:active .item-icon-wrapper {
  transform: scale(0.9);
}

/* 预定义的图标背景色 */
.icon-bg-0 { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
.icon-bg-1 { background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 99%, #fecfef 100%); }
.icon-bg-2 { background: linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%); }
.icon-bg-3 { background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%); }
.icon-bg-4 { background: linear-gradient(135deg, #fccb90 0%, #d57eeb 100%); }

.item-icon {
  width: 80%;
  height: 80%;
  object-fit: cover;
  border-radius: 18px;
}

.avatar-text-phone {
  font-size: 20px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.item-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  text-align: center;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 弹窗样式重写 */
::v-deep .glass-dialog {
  background: rgba(245, 247, 250, 0.95);
  backdrop-filter: blur(10px);
}

::v-deep .glass-dialog .el-dialog__header {
  display: none; /* 隐藏默认头部，使用自定义头部 */
}

::v-deep .glass-dialog .el-dialog__body {
  padding: 0;
  height: 100%;
  overflow-y: auto;
}

.dialog-header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.back-btn {
  display: flex;
  align-items: center;
  color: #409EFF;
  font-size: 16px;
  cursor: pointer;
}

.back-btn i {
  margin-right: 4px;
  font-size: 18px;
}

.dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.placeholder {
  width: 50px; /* 占位，保持标题居中 */
}

.dialog-content {
  padding: 20px;
}

/* 动画 */
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>